import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import formStyles from '../styles/forms.styles';
export default css `
${componentStyles}
${formStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.input {
  width:100%;
  max-width: 100%;
  border: 1px solid var(--p-input-border-color);
  font-family: var(--p-input-font);
  font-weight: var(--p-input-font-weight);
  font-size: var(--p-input-font-size);
  letter-spacing: var(--p-input-letter-spacing);
  border-radius: var(--p-input-border-radius);
  padding: var(--p-input-padding);
  background-color: var(--p-input-bg);
  color: var(--p-input-text-color);
  transition: border-color 0.25s ease;
  border-width: var(--p-input-border-width);
  border-style: solid;
  border-color: var(--p-input-border-color);
  z-index: 1;
  -webkit-appearance: none;
  appearance: none;
  display: block;
}

.input:hover {
  border-color: var(--p-input-border-color-hover);
  background-color: var(--p-input-bg-hover);
}

.input:focus {
  border-color: var(--p-input-border-color-focus);
  outline: 1px solid var(--p-input-border-color-focus);
  outline-offset: 0;
  box-shadow: none;
}

/**
--------------------------------------------------
* Sizes
--------------------------------------------------
*/
.small {
  --p-input-height: var(--p-input-height-small);
  --p-input-font-size: .875rem;
  --p-label-font-size: .875rem;
  --p-help-font-size: .75rem;
  --p-error-font-size: .75rem;
}

/**
--------------------------------------------------
* Error
--------------------------------------------------
*/
.has-error .input {
  border-color: var(--p-error);
}

.has-error .input:focus {
  outline: 1px solid var(--p-error);
}

/**
--------------------------------------------------
* Placeholder
--------------------------------------------------
*/
.input::placeholder {
  color: var(--p-input-placeholder-text-color);
}
`;
